import React from 'react';

import clsx from 'clsx';
import PropTypes from 'prop-types';

import { IconDirection } from 'constants/coreDesignSystem';

import { defaultSize, rotationEnum, sizePropsTypes } from './icons.constants';

const EntryIcon = ({ size = defaultSize, direction = IconDirection.DOWN, className, ...props }) => {
  return (
    <svg
      className={clsx(rotationEnum[direction], className)}
      fill="none"
      height={size}
      viewBox="0 0 24 24"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM11.2929 8.70711C10.9024 8.31658 10.9024 7.68342 11.2929 7.29289C11.6834 6.90237 12.3166 6.90237 12.7071 7.29289L16.7071 11.2929C17.0976 11.6834 17.0976 12.3166 16.7071 12.7071L12.7071 16.7071C12.3166 17.0976 11.6834 17.0976 11.2929 16.7071C10.9024 16.3166 10.9024 15.6834 11.2929 15.2929L13.5858 13H8C7.44772 13 7 12.5523 7 12C7 11.4477 7.44772 11 8 11H13.5858L11.2929 8.70711Z"
        fill="CurrentColor"
        fillRule="evenodd"
      />
    </svg>
  );
};

EntryIcon.propTypes = {
  ...sizePropsTypes,
  direction: PropTypes.oneOf(Object.keys(rotationEnum)),
  className: PropTypes.string,
};

export default EntryIcon;
